import type { Material } from './material.interface';

export interface MaterialPriorMaterialPool {
    C_Material_key: number;
    HousingID: string;
    HousingIDSortable: string;
    Material: Material;
}
